/*
 * shipping-logic-se-fi.js
 * Sweden / Finland delivery estimate + order cutoff countdown.
 *
 * Idempotent by design. A single 1s tick re-reads the DOM and rewrites every
 * widget instance it finds. Combined-listing colour switches replace the
 * product section, so anything that binds once to a captured node freezes.
 * Nothing in here holds a node reference between ticks.
 */
(function () {
  if (window.__npShippingSeFi) return;
  window.__npShippingSeFi = true;

  var ZONE = 'Europe/Stockholm';
  var CUTOFF_HOUR = 17;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // [month, day] pairs. NOTE: the Easter-dependent entries below are 2026 dates.
  // They need updating each year, same as the original file.
  var HOLIDAYS = [
    [1, 1],   // New Year's Day
    [1, 6],   // Epiphany
    [4, 2],   // Thu before Good Friday
    [4, 3],   // Good Friday
    [4, 4],   // Sat before Easter
    [4, 5],   // Easter Sunday
    [4, 6],   // Easter Monday
    [5, 1],   // May Day
    [5, 14],  // Ascension Day
    [5, 24],  // Whit Sunday
    [6, 6],   // National Day
    [6, 19],  // Midsummer Eve
    [6, 20],  // Midsummer Day
    [10, 31], // All Saints' Day
    [12, 24], // Christmas Eve
    [12, 25], // Christmas Day
    [12, 26], // 2nd Day of Christmas
    [12, 31]  // New Year's Eve
  ];

  var BLACKOUT = [[4, 2], [4, 3], [4, 4], [4, 5], [4, 6], [5, 14], [6, 19]];

  // Holiday maths runs once per day rather than once per second.
  var cache = { key: null, data: null };

  function matches(list, d) {
    for (var i = 0; i < list.length; i++) {
      if (d.month === list[i][0] && d.day === list[i][1]) return true;
    }
    return false;
  }

  function isHoliday(d) { return matches(HOLIDAYS, d); }
  function isBlackout(d) { return matches(BLACKOUT, d); }

  function nextBusinessDay(d) {
    do { d = d.plus({ days: 1 }); } while (d.weekday > 5 || isHoliday(d));
    return d;
  }

  function computeDay(now) {
    var hour = now.hour;
    var day = now.weekday; // 1 = Mon ... 7 = Sun
    var shippingDate;
    var deliveryDate;

    if (day >= 1 && day <= 4) {
      if (hour < CUTOFF_HOUR && !isHoliday(now)) {
        shippingDate = now;
        deliveryDate = nextBusinessDay(now);
      } else {
        shippingDate = nextBusinessDay(now);
        deliveryDate = nextBusinessDay(shippingDate);
      }
    } else if (day === 5) {
      if (hour < CUTOFF_HOUR && !isHoliday(now)) {
        shippingDate = now;
        deliveryDate = nextBusinessDay(now.plus({ days: 1 }));
      } else {
        shippingDate = nextBusinessDay(now);
        deliveryDate = nextBusinessDay(shippingDate);
      }
    } else {
      shippingDate = nextBusinessDay(now);
      deliveryDate = nextBusinessDay(shippingDate);
    }

    if (isHoliday(shippingDate)) shippingDate = nextBusinessDay(shippingDate);
    if (isHoliday(deliveryDate)) deliveryDate = nextBusinessDay(deliveryDate);

    function label(d) {
      if (d.hasSame(now, 'day')) return 'Today';
      if (d.hasSame(now.plus({ days: 1 }), 'day')) return 'Tomorrow';
      return MONTHS[d.month - 1] + ' ' + d.day;
    }

    return {
      shipping: label(shippingDate),
      delivery: label(deliveryDate),
      // Preserves the original behaviour: whole widget hidden on Fridays and
      // on blackout dates.
      hideWidget: day === 5 || isBlackout(now)
    };
  }

  function cutoffTarget(now) {
    var base = now.hour >= CUTOFF_HOUR ? now.plus({ days: 1 }) : now;
    return base.set({ hour: CUTOFF_HOUR, minute: 0, second: 0, millisecond: 0 });
  }

  function pad(n) {
    return String(Math.max(0, Math.floor(n || 0))).padStart(2, '0');
  }

  function setAll(selector, value) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== value) nodes[i].textContent = value;
    }
  }

  function tick() {
    if (!window.luxon) return;

    var now = luxon.DateTime.now().setZone(ZONE);
    var key = now.toISODate() + (now.hour >= CUTOFF_HOUR ? 'B' : 'A');
    if (cache.key !== key) {
      cache.key = key;
      cache.data = computeDay(now);
    }
    var day = cache.data;

    var containers = document.querySelectorAll('.delivery__container');
    for (var i = 0; i < containers.length; i++) {
      containers[i].style.display = day.hideWidget ? 'none' : 'block';
    }

    setAll('.date__estimated', day.shipping);
    setAll('.date__delivery', day.delivery);

    var remaining = cutoffTarget(now).diff(now, ['hours', 'minutes', 'seconds']).toObject();
    var text = pad(remaining.hours) + ':' + pad(remaining.minutes) + ':' + pad(remaining.seconds);
    var hideCountdown = now.weekday === 5 && now.hour >= CUTOFF_HOUR;

    var timers = document.querySelectorAll('.countdown__timer');
    for (var j = 0; j < timers.length; j++) {
      timers[j].style.display = hideCountdown ? 'none' : '';
      var timeEl = timers[j].querySelector('.countdown__time');
      if (timeEl && timeEl.textContent !== text) timeEl.textContent = text;
    }
  }

  // Immediate repaint on swap so there is no sub-second blank, on top of the
  // 1s tick that would catch it anyway.
  var pending = false;
  function scheduleTick() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      tick();
    });
  }

  function watchForSwaps() {
    if (typeof MutationObserver !== 'function') return;

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches('.delivery__container')) ||
              (node.querySelector && node.querySelector('.delivery__container'))) {
            scheduleTick();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() {
    if (!window.luxon) {
      setTimeout(boot, 50);
      return;
    }
    tick();
    setInterval(tick, 1000);
    watchForSwaps();
    ['shopify:section:load', 'popstate', 'pageshow'].forEach(function (evt) {
      window.addEventListener(evt, scheduleTick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
